// localhost, production
const testingType = "production";

// /*
// Production System
export const keycloakConfig = {
  url: "https://security.vib3d.dmt-group.com/",
  realm: "vib3d",
  clientId: "vib3d-user",
};

const settings = {
  apiUrl:
    testingType === "localhost"
      ? "http://localhost:7000/"
      : "https://api.vib3d.dmt-group.com/",
  keycloakAuthUrl:
    keycloakConfig.url +
    "/realms/" +
    keycloakConfig.realm +
    "/protocol/openid-connect/token",
  logoutUrl:
    keycloakConfig.url +
    "/realms/" +
    keycloakConfig.realm +
    "/protocol/openid-connect/logout",
  logoutRedirect:
    process.env.NODE_ENV === "development"
      ? "http://localhost:3000"
      : "https://vib3d.dmt-group.com/",
};
// */

/*
// Testing System
export const keycloakConfig = {
  url: "https://security.vib3d.dmt-group.com/",
  realm: "vib3d-test",
  clientId: "vib3d-user",
};

const settings = {
  apiUrl:
    testingType === "localhost"
      ? "http://localhost:7000/"
      : "http://10.116.248.36:5000/",

  // apiUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:7000' :'https://api.vib3d.dmt-group.com/',
  keycloakAuthUrl:
    keycloakConfig.url +
    "/realms/" +
    keycloakConfig.realm +
    "/protocol/openid-connect/token",
  logoutUrl:
    keycloakConfig.url +
    "/realms/" +
    keycloakConfig.realm +
    "/protocol/openid-connect/logout",
  logoutRedirect:
    process.env.NODE_ENV === "development"
      ? "http://localhost:3000"
      : "https://vib3d.dmt-group.com/",
};
*/
export default settings;
